export const EditorConfig = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],
    [{ align: '' }, { align: 'center' }, { align: 'right' }],
    [{ list: 'ordered' }, { list: 'bullet' }, 'link'],
  ],
  allowedTags: ['p', 'br', 'b', 'strong', 'i', 'em', 'u', 's', 'a', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4'],
  allowedAttributes: {
    p: ['class'],
    a: ['href', 'rel', 'target'],
  },
};
